import React from 'react';
import Modal from '../Base/Modal';
import { iosInstallUrl, androidInstallUrl } from '../../constants/Urls';
import openWithApp from '../../utils/openWithApp';

const AddFriendModal = ({ hideModal, device, profile, post }) => {
  const deviceOs = device.getIn(['os', 'name']);
  const marketUrl = 'https://itunes.apple.com/kr/app/kakaotog-kakaotalk/id362057947';
  const packageName = 'com.kakao.talk';

  return (
    <Modal
      contentLabel="채널 추가"
      onRequestClose={hideModal}
    >
      {{
        renderTitle: () => (<span>채널 추가는 카카오톡<br />모바일앱에서 가능합니다.</span>),
        renderContent: () => (
          <div className="app_btn">
            <button type="button" className="btn_g"
              onClick={() =>
                openWithApp(deviceOs, 'kakaoplus', (post || profile).getSchemeHost(), packageName, marketUrl)}
            >
              <span className="inner_txt">카카오톡앱 열기</span>
            </button>
            <button type="button" className="btn_g btn_g2"
                    onClick={() => window.open(device.getIn(['os', 'name']) === 'iOS' ? iosInstallUrl : androidInstallUrl)}>
              <span className="inner_txt">카카오톡앱 설치하기</span>
            </button>
          </div>
        )
      }}
    </Modal>
  );
}

export default AddFriendModal;



// WEBPACK FOOTER //
// ./src/components/AddFriendModal/index.js